export function ChartPanel() {
  return (
    <section className="panel panel-center">
      <div className="workspace-chart" id="plotContainer">
        <div id="plotDiv" className="plotly-container" />
      </div>
      <p className="workspace-placeholder" id="workspacePlaceholder">
        Load a file and click Plot to see the chart here.
      </p>
    </section>
  );
}
